import { createAction, props, createFeatureSelector, createSelector, Store, createReducer, on, StoreModule } from '@ngrx/store';
import { __decorate } from 'tslib';
import { CommonModule } from '@angular/common';
import { Injectable, NgModule } from '@angular/core';
import { createEffect, ofType, Actions, EffectsModule } from '@ngrx/effects';
import { routerReducer, StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { BaseAPIService } from '@lbmx/phoenix-lib-core';
import { of, throwError, iif, EMPTY } from 'rxjs';
import { exhaustMap, map, catchError, tap, withLatestFrom } from 'rxjs/operators';
import { ToastrNotificationService } from '@lbmx/phoenix-lib-utils/';
import { TranslocoService } from '@ngneat/transloco';
import { SuccessMessageService } from '@lbmx/phoenix-lib-utils';

const loadAnalyticsConfig = createAction('[App] Load Analytics Configuration', props());
const loadAnalyticsConfigFailure = createAction('[App] Load Analytics Configuration Failure');
const loadAnalyticsConfigSuccess = createAction('[App] Load Analytics Configuration Success', props());

const loadCountries = createAction('[App] Load Countries', props());
const loadCountriesFailure = createAction('[App] Load Countries Failure');
const loadCountriesSuccess = createAction('[App] Load Countries Success', props());
const loadProvinces = createAction('[App] Load Provinces', props());
const loadProvincesFailure = createAction('[App] Load Provinces Failure');
const loadProvincesSuccess = createAction('[App] Load Provinces Success', props());

const setNavItems = createAction('[App] Set Nav Items', props());
const setNavItemsSuccess = createAction('[App] Set Nav Items Success', props());
const setNavItemsFailure = createAction('[App] Set Nav Items Failure');
const setTranslatedNavItemsSuccess = createAction('[App] Set Translated Nav Items Success', props());
const setTranslatedNavItemsFailure = createAction('[App] Set Translated Nav Items Failure');

const loadCategories = createAction('[App] Load Categories', props());
const loadCategoriesFailure = createAction('[App] Load Categories Failure');
const loadCategoriesSuccess = createAction('[App] Load Categories Success', props());
const loadProductFields = createAction('[App] Load Product fields', props());
const loadProductFieldsFailure = createAction('[App] Load Product failure');
const loadProductFieldsSuccess = createAction('[App] Load Product Fields Success', props());
const updateProductField = createAction('[App] Update Product Field', props());
const updateProductFields = createAction('[App] Update Product Fields', props());
const updateProductFieldsFailure = createAction('[App] Update Product Fields Failure');
const updateProductFieldsSuccess = createAction('[App] Update Product Fields Success', props());

const loadUserProfile = createAction('[App] Load UserProfile', props());
const loadUserProfileFailure = createAction('[App] Load UserProfile Failure');
const loadUserProfileSuccess = createAction('[App] Load UserProfile Success', props());
const refreshUserProfile = createAction('[App] Refresh UserProfile', props());
const updateUserProfileMarketplace = createAction('[App] Update UserProfile Marketplace', props());
const refreshUserProfileFailure = createAction('[App] Refresh UserProfile Failure', props());
const refreshUserProfileSuccess = createAction('[App] Refresh UserProfile Success', props());
const getMarketplaces = createAction('[App] Get marketplaces', props());
const getMarketplacesSuccess = createAction('[App] Get Marketplaces Success', props());
const getMarketplacesFailure = createAction('[App] Get Marketplaces Failure');
const logout = createAction('[App] Logout', props());
const logoutSuccess = createAction('[App] Logout Success');
const logoutFailure = createAction('[App] Logout Failure');
const unloadUserProfile = createAction('[App] Unload UserProfile');
const updateUserProfile = createAction('[App] Update UserProfile', props());
const updateUserProfileFromForm = createAction('[App] Update UserProfile From Form', props());
const updateUserProfileFailure = createAction('[App] Update UserProfile Failure');
const updateUserProfileSuccess = createAction('[App] Update UserProfile Success', props());
const agreeToTerms = createAction('[App] Agree to Terms', props());
const loadSettings = createAction('[App] Load Settings', props());
const loadSettingsFailure = createAction('[App] Load Settings Failure', props());
const loadSettingsSuccess = createAction('[App] Load Settings Success', props());
const updateSettings = createAction('[App] Update Settings', props());
const updateSettingsFailure = createAction('[App] Update Settings Failure');
const updateSettingsSuccess = createAction('[App] Update Settings Success', props());
const updateUser = createAction('[App] Update User');
const getAccounts = createAction('[App] Get Accounts', props());
const getAccountsSuccess = createAction('[App] Get Accounts Success', props());
const getAccountsFailure = createAction('[App] Get Accounts Failure');
const setAccount = createAction('[App] Set Account', props());
const setAccountSuccess = createAction('[App] Set Account Success', props());
const setAccountFailure = createAction('[App] Set Account Failure');

const loadUsers = createAction('[App] Load Users', props());
const loadUsersSuccess = createAction('[App] Load Users Success', props());
const loadUsersFailure = createAction('[App] Load Users Failure');
const unloadUsers = createAction('[App] Unload Users');

var index = /*#__PURE__*/Object.freeze({
    __proto__: null,
    loadAnalyticsConfig: loadAnalyticsConfig,
    loadAnalyticsConfigFailure: loadAnalyticsConfigFailure,
    loadAnalyticsConfigSuccess: loadAnalyticsConfigSuccess,
    loadCountries: loadCountries,
    loadCountriesFailure: loadCountriesFailure,
    loadCountriesSuccess: loadCountriesSuccess,
    loadProvinces: loadProvinces,
    loadProvincesFailure: loadProvincesFailure,
    loadProvincesSuccess: loadProvincesSuccess,
    setNavItems: setNavItems,
    setNavItemsSuccess: setNavItemsSuccess,
    setNavItemsFailure: setNavItemsFailure,
    setTranslatedNavItemsSuccess: setTranslatedNavItemsSuccess,
    setTranslatedNavItemsFailure: setTranslatedNavItemsFailure,
    loadCategories: loadCategories,
    loadCategoriesFailure: loadCategoriesFailure,
    loadCategoriesSuccess: loadCategoriesSuccess,
    loadProductFields: loadProductFields,
    loadProductFieldsFailure: loadProductFieldsFailure,
    loadProductFieldsSuccess: loadProductFieldsSuccess,
    updateProductField: updateProductField,
    updateProductFields: updateProductFields,
    updateProductFieldsFailure: updateProductFieldsFailure,
    updateProductFieldsSuccess: updateProductFieldsSuccess,
    loadUserProfile: loadUserProfile,
    loadUserProfileFailure: loadUserProfileFailure,
    loadUserProfileSuccess: loadUserProfileSuccess,
    refreshUserProfile: refreshUserProfile,
    updateUserProfileMarketplace: updateUserProfileMarketplace,
    refreshUserProfileFailure: refreshUserProfileFailure,
    refreshUserProfileSuccess: refreshUserProfileSuccess,
    getMarketplaces: getMarketplaces,
    getMarketplacesSuccess: getMarketplacesSuccess,
    getMarketplacesFailure: getMarketplacesFailure,
    logout: logout,
    logoutSuccess: logoutSuccess,
    logoutFailure: logoutFailure,
    unloadUserProfile: unloadUserProfile,
    updateUserProfile: updateUserProfile,
    updateUserProfileFromForm: updateUserProfileFromForm,
    updateUserProfileFailure: updateUserProfileFailure,
    updateUserProfileSuccess: updateUserProfileSuccess,
    agreeToTerms: agreeToTerms,
    loadSettings: loadSettings,
    loadSettingsFailure: loadSettingsFailure,
    loadSettingsSuccess: loadSettingsSuccess,
    updateSettings: updateSettings,
    updateSettingsFailure: updateSettingsFailure,
    updateSettingsSuccess: updateSettingsSuccess,
    updateUser: updateUser,
    getAccounts: getAccounts,
    getAccountsSuccess: getAccountsSuccess,
    getAccountsFailure: getAccountsFailure,
    setAccount: setAccount,
    setAccountSuccess: setAccountSuccess,
    setAccountFailure: setAccountFailure,
    loadUsers: loadUsers,
    loadUsersSuccess: loadUsersSuccess,
    loadUsersFailure: loadUsersFailure,
    unloadUsers: unloadUsers
});

const analyticsFeature = createFeatureSelector('analytics');
const ɵ0 = (state) => state;
const analyticsConfig = createSelector(analyticsFeature, ɵ0);

const configFeature = createFeatureSelector('config');
const ɵ0$1 = (state) => state.countries;
const countries = createSelector(configFeature, ɵ0$1);
const ɵ1 = (countriesState) => countriesState.map((country) => ({
    label: country.name,
    value: country.code,
}));
const countriesDropdown = createSelector(countries, ɵ1);
const ɵ2 = (state) => state.provinces;
const provinces = createSelector(configFeature, ɵ2);
const ɵ3 = (provincesState, props) => provincesState.reduce((provincesList, province) => province.countryCode === props.countryCode
    ? [...provincesList, { code: province.code, name: province.name }]
    : provincesList, []);
const provincesSelector = createSelector(provinces, ɵ3);
const ɵ4 = (provincesState, props) => provincesState.reduce((provincesList, province) => province.countryCode === props.countryCode
    ? [...provincesList, { value: province.code, label: province.name }]
    : provincesList, []);
const provincesDropdown = createSelector(provinces, ɵ4);

const navItemsFeature = createFeatureSelector('navItems');
const ɵ0$2 = (state) => state;
const navItems = createSelector(navItemsFeature, ɵ0$2);

const sortFields = (a, b) => {
    const catDiff = a.categoryKey - b.categoryKey;
    if (catDiff === 0) {
        if (a.fieldKey === 1) {
            return -1;
        }
        else if (b.fieldKey === 1) {
            return 1;
        }
        else {
            if (a.isRequired && b.isRequired) {
                return a.fieldKey - b.fieldKey;
            }
            else if (a.isRequired && !b.isRequired) {
                return -1;
            }
            else if (!a.isRequired && b.isRequired) {
                return 1;
            }
            else {
                if (a.isReadOnly && b.isReadOnly) {
                    return a.fieldKey - b.fieldKey;
                }
                else if (a.isReadOnly && !b.isReadOnly) {
                    return -1;
                }
                else if (!a.isReadOnly && b.isReadOnly) {
                    return 1;
                }
                else {
                    if (a.description.toLocaleLowerCase().trim() >
                        b.description.toLocaleLowerCase().trim()) {
                        return 1;
                    }
                    else if (a.description.toLocaleLowerCase().trim() ===
                        b.description.toLocaleLowerCase().trim()) {
                        return 0;
                    }
                    else {
                        return -1;
                    }
                }
            }
        }
    }
    else {
        return catDiff;
    }
};

const productFeature = createFeatureSelector('product');
const ɵ0$3 = (state) => state.categories;
const categories = createSelector(productFeature, ɵ0$3);
const ɵ1$1 = (state) => state.productFields;
const productFields = createSelector(productFeature, ɵ1$1);
const ɵ2$1 = (state) => Object.values(state).filter((field) => !field.isImported);
const readOnlyFields = createSelector(productFields, ɵ2$1);
const ɵ3$1 = (categoriesState, productFieldsState) => {
    const categorized = categorizeProducts(productFieldsState);
    return Object.entries(categoriesState).map(([id, categoryName]) => {
        return {
            data: { categoryName },
            children: Object.values(categorized[id] || {}).map((productField) => ({
                data: productField,
            })),
            parent: null,
        };
    });
};
const treeNodeList = createSelector(categories, productFields, ɵ3$1);
const ɵ4$1 = (productFieldsState) => {
    return Object.values(productFieldsState)
        .map((f) => f)
        .sort(sortFields);
};
const sortedFields = createSelector(productFields, ɵ4$1);
const ɵ5 = (categoriesState) => {
    return Object.entries(categoriesState)
        .map(([key, value]) => ({
        categoryKey: parseInt(key, 10),
        categoryName: value,
    }))
        .sort((a, b) => a.categoryKey - b.categoryKey);
};
const rawCategories = createSelector(categories, ɵ5);
function categorizeProducts(products) {
    return Object.values(products).reduce((categorized, product) => {
        const { categoryKey, fieldKey } = product;
        return Object.assign(Object.assign({}, categorized), { [categoryKey]: Object.assign(Object.assign({}, categorized[categoryKey]), { [fieldKey]: Object.assign({}, product) }) });
    }, {});
}

const userFeature = createFeatureSelector('user');
const ɵ0$4 = ({ tokenExpires, tokenIssued, sessionExpires }) => ({
    tokenExpires,
    tokenIssued,
    sessionExpires,
});
const session = createSelector(userFeature, ɵ0$4);
const ɵ1$2 = ({ tokenExpires }) => {
    return new Date(tokenExpires) > new Date();
};
const loggedIn = createSelector(userFeature, ɵ1$2);
const ɵ2$2 = (state) => state.profile;
const userProfile = createSelector(userFeature, ɵ2$2);
const ɵ3$2 = (user) => user.settings;
const settings = createSelector(userFeature, ɵ3$2);
const ɵ4$2 = (userSettings, { key }) => {
    const coalescedSetting = userSettings ? userSettings[key] : null;
    return coalescedSetting;
};
const setting = createSelector(settings, ɵ4$2);
const ɵ5$1 = (state) => ({
    marketplace: state.marketplace,
    marketplaces: state.marketplaces,
});
const marketplaces = createSelector(userFeature, ɵ5$1);
const ɵ6 = ({ toolKeys }) => {
    return toolKeys;
};
const userToolKeys = createSelector(userProfile, ɵ6);
const ɵ7 = ({ toolKeys }, permissionQuery) => mapPermissions(toolKeys, permissionQuery);
const isAuthorized = createSelector(userProfile, ɵ7);
const ɵ8 = ({ toolKeys }, { marketplaces: mp }, args) => {
    return _authorize(args.itemList, args.transformer, args.recursiveProp, args.permissionProp, toolKeys, mp != null && mp.length > 1);
};
const authorizeRecursively = createSelector(userProfile, userFeature, ɵ8);
// Helper methods
function mapPermissions(toolKeys, permissionQuery) {
    return Object.entries(permissionQuery).reduce((permissions, [name, toolKey]) => {
        return Object.assign(Object.assign({}, permissions), { [name]: toolKeys.includes(toolKey) });
    }, {});
}
function _authorize(itemList, transformer, recursiveProp = '', permissionProp = '', toolKeys, allowSwitchMarketplace) {
    return itemList.map((item) => {
        return Object.assign({}, item, transformer(item, item[permissionProp] &&
            item[permissionProp].every((key) => toolKeys.includes(key)), allowSwitchMarketplace), item[recursiveProp] && {
            [recursiveProp]: _authorize(item[recursiveProp], transformer, recursiveProp, permissionProp, toolKeys, allowSwitchMarketplace),
        });
    });
}

const usersFeature = createFeatureSelector('users');
const ɵ0$5 = (state) => state;
const users = createSelector(usersFeature, ɵ0$5);

var index$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    analyticsFeature: analyticsFeature,
    analyticsConfig: analyticsConfig,
    ɵ0: ɵ0,
    configFeature: configFeature,
    countries: countries,
    countriesDropdown: countriesDropdown,
    provinces: provinces,
    provincesSelector: provincesSelector,
    provincesDropdown: provincesDropdown,
    ɵ1: ɵ1,
    ɵ2: ɵ2,
    ɵ3: ɵ3,
    ɵ4: ɵ4,
    navItemsFeature: navItemsFeature,
    navItems: navItems,
    productFeature: productFeature,
    categories: categories,
    productFields: productFields,
    readOnlyFields: readOnlyFields,
    treeNodeList: treeNodeList,
    sortedFields: sortedFields,
    rawCategories: rawCategories,
    ɵ5: ɵ5,
    userFeature: userFeature,
    session: session,
    loggedIn: loggedIn,
    userProfile: userProfile,
    settings: settings,
    setting: setting,
    marketplaces: marketplaces,
    userToolKeys: userToolKeys,
    isAuthorized: isAuthorized,
    authorizeRecursively: authorizeRecursively,
    ɵ6: ɵ6,
    ɵ7: ɵ7,
    ɵ8: ɵ8,
    usersFeature: usersFeature,
    users: users
});

var index$2 = /*#__PURE__*/Object.freeze({
    __proto__: null
});

const reducer = {};

let ConfigEffects = class ConfigEffects {
    constructor(actions$, baseAPIService) {
        this.actions$ = actions$;
        this.baseAPIService = baseAPIService;
        this.loadCountries$ = createEffect(() => this.actions$.pipe(ofType(loadCountries), exhaustMap((action) => {
            this.baseAPIService.set(action.endPoints.getCountries);
            return this.baseAPIService.get().pipe(map(this.transformCountries), catchError(() => of(loadCountriesFailure())));
        })));
        this.loadProvinces$ = createEffect(() => this.actions$.pipe(ofType(loadProvinces), exhaustMap((action) => {
            this.baseAPIService.set(action.endPoints.getProvinces);
            return this.baseAPIService.get().pipe(map(this.transformProvinces), catchError(() => of(loadProvincesFailure())));
        })));
    }
    transformCountries(result) {
        const countries = result.map((c) => ({
            code: c.CountryCode,
            name: c.CountryName,
        }));
        return loadCountriesSuccess({
            countries,
        });
    }
    transformProvinces(result) {
        const provinces = result.map((c) => ({
            code: c.ProvinceCode.trim(),
            countryCode: c.CountryCode,
            name: c.ProvinceName,
        }));
        return loadProvincesSuccess({
            provinces,
        });
    }
};
ConfigEffects.ctorParameters = () => [
    { type: Actions },
    { type: BaseAPIService }
];
ConfigEffects = __decorate([
    Injectable()
], ConfigEffects);

let ProductEffects = class ProductEffects {
    constructor(actions$, baseAPIService, msgService, translocoSrv) {
        this.actions$ = actions$;
        this.baseAPIService = baseAPIService;
        this.msgService = msgService;
        this.translocoSrv = translocoSrv;
        this.loadCategories$ = createEffect(() => this.actions$.pipe(ofType(loadCategories), exhaustMap((action) => {
            this.baseAPIService.set(action.endPoints.getFieldCategories);
            return this.baseAPIService.get().pipe(map(this.transformCategories), catchError(() => of(loadCategoriesFailure())));
        })));
        this.loadProducts$ = createEffect(() => this.actions$.pipe(ofType(loadProductFields), exhaustMap((action) => {
            this.baseAPIService.set(action.endPoints.getAllProductFields);
            return this.baseAPIService.get().pipe(map(this.transformProducts), catchError(() => of(loadProductFieldsFailure())));
        })));
        this.updateProducts$ = createEffect(() => this.actions$.pipe(ofType(updateProductFields), exhaustMap((action) => {
            this.baseAPIService.set(action.endPoints.updateFieldConfigurations);
            return this.baseAPIService
                .post(this.updatedProducts(action.productFields))
                .pipe(map(() => loadProductFields({
                endPoints: action.endPoints,
            })), tap(() => {
                this.msgService.successNotify(this.translocoSrv.translate('PIM.PRODUCT_FIELD_SAVE_SUCCESS'));
            }), catchError((err) => {
                this.msgService.errorNotify(this.translocoSrv.translate('PIM.PRODUCT_FIELD_SAVE_FAILURE'));
                of(updateProductFieldsFailure());
                return throwError(err);
            }));
        })));
    }
    transformCategories(result) {
        const categories = result.reduce((prev, { categoryKey, categoryName }) => {
            return Object.assign(Object.assign({}, prev), { [categoryKey]: categoryName });
        }, {});
        return loadCategoriesSuccess({ categories });
    }
    transformProducts(result) {
        const productFields = result.reduce((prev, product) => {
            return Object.assign(Object.assign({}, prev), { [product.fieldKey]: Object.assign({}, product) });
        }, {});
        return loadProductFieldsSuccess({ productFields });
    }
    // change the shape of our state so it matches our API
    updatedProducts(prods) {
        return Object.values(prods).map(({ categoryKey, fieldKey, dataType, fieldName, isIncluded, isRecommended, isExcludedFromUpdates, }) => {
            return {
                categoryKey,
                fieldKey,
                dataType,
                fieldName,
                isIncluded,
                isRecommended,
                isExcludedFromUpdates,
            };
        });
    }
};
ProductEffects.ctorParameters = () => [
    { type: Actions },
    { type: BaseAPIService },
    { type: ToastrNotificationService },
    { type: TranslocoService }
];
ProductEffects = __decorate([
    Injectable()
], ProductEffects);

const actionTypes = {
    // Analytics Configuration actions
    LOAD_ANALYTICS_CONFIGURATION: loadAnalyticsConfig.type,
    LOAD_ANALYTICS_CONFIGURATION_FAILURE: loadAnalyticsConfigFailure.type,
    LOAD_ANALYTICS_CONFIGURATION_SUCCESS: loadAnalyticsConfigSuccess.type,
    // config actions
    LOAD_COUNTRIES: loadCountries.type,
    LOAD_COUNTRIES_FAILURE: loadCountriesFailure.type,
    LOAD_COUNTRIES_SUCCESS: loadCountriesSuccess.type,
    LOAD_PROVINCES: loadProvinces.type,
    LOAD_PROVINCES_FAILURE: loadProvincesFailure.type,
    LOAD_PROVINCES_SUCCESS: loadProvincesSuccess.type,
    // nav-items actions
    SET_NAV_ITEMS: setNavItems.type,
    SET_TRANSLATED_NAV_ITEMS_SUCCESS: setTranslatedNavItemsSuccess.type,
    SET_TRANSLATED_NAV_ITEMS_FAILURE: setTranslatedNavItemsFailure.type,
    // product actions
    LOAD_CATEGORIES: loadCategories.type,
    LOAD_CATEGORIES_FAILURE: loadCategoriesFailure.type,
    LOAD_CATEGORIES_SUCCESS: loadCategoriesSuccess.type,
    LOAD_PRODUCT_FIELDS: loadProductFields.type,
    LOAD_PRODUCT_FIELDS_FAILURE: loadProductFieldsFailure.type,
    LOAD_PRODUCT_FIELDS_SUCCESS: loadProductFieldsSuccess.type,
    UPDATE_PRODUCT_FIELD: updateProductField.type,
    UPDATE_PRODUCT_FIELDS: updateProductFields.type,
    UPDATE_PRODUCT_FIELDS_FAILURE: updateProductFieldsFailure.type,
    UPDATE_PRODUCT_FIELDS_SUCCESS: updateProductFieldsSuccess.type,
    // user actions
    LOAD_USER_PROFILE: loadUserProfile.type,
    LOAD_USER_PROFILE_FAILURE: loadUserProfileFailure.type,
    LOAD_USER_PROFILE_SUCCESS: loadUserProfileSuccess.type,
    LOAD_MARKETPLACE: getMarketplaces.type,
    LOAD_MARKETPLACE_SUCCESS: getMarketplacesSuccess.type,
    LOAD_MARKETPLACE_FAILURE: getMarketplacesFailure.type,
    REFRESH_USER_PROFILE: refreshUserProfile.type,
    UPDATE_USER_PROFILE_MARKETPLACE: updateUserProfileMarketplace.type,
    REFRESH_USER_PROFILE_FAILURE: refreshUserProfileFailure.type,
    REFRESH_USER_PROFILE_SUCCESS: refreshUserProfileSuccess.type,
    LOGOUT: logout.type,
    LOGOUT_SUCCESS: logoutSuccess.type,
    LOGOUT_FAILURE: logoutFailure.type,
    UNLOAD_USER_PROFILE: unloadUserProfile.type,
    UPDATE_USER_PROFILE: updateUserProfile.type,
    UPDATE_USER_PROFILE_FROM_FORM: updateUserProfileFromForm.type,
    UPDATE_USER_PROFILE_FAILURE: updateUserProfileFailure.type,
    UPDATE_USER_PROFILE_SUCCESS: updateUserProfileSuccess.type,
    AGREE_TO_TERMS: agreeToTerms.type,
    // users actions
    LOAD_USERS: loadUsers.type,
    LOAD_USERS_SUCCESS: loadUsersSuccess.type,
    LOAD_USERS_FAILURE: loadUsersFailure.type,
    UNLOAD_USERS: unloadUsers.type,
};

let UserEffects = class UserEffects {
    constructor(actions$, baseAPIService, store$) {
        this.actions$ = actions$;
        this.baseAPIService = baseAPIService;
        this.store$ = store$;
        this.loadUserProfile$ = createEffect(() => this.actions$.pipe(ofType(loadUserProfile), exhaustMap((action) => {
            this.baseAPIService.set(action.endPoints.uriSecurity.getProfile);
            return this.baseAPIService.get().pipe(map(this.transformUserProfile), map((userProfile) => loadUserProfileSuccess({ userProfile })), catchError(() => of(loadUserProfileFailure())));
        })));
        this.refreshUserProfile$ = createEffect(() => {
            return this.actions$.pipe(ofType(updateUserProfileSuccess, setAccountSuccess, refreshUserProfile), withLatestFrom(this.store$), exhaustMap(([action, store]) => {
                const timeDiff = (new Date(store.user.tokenExpires).valueOf() -
                    new Date(store.user.tokenIssued).valueOf()) /
                    2;
                const refreshThreshold = new Date(store.user.tokenIssued).valueOf() + timeDiff;
                if (new Date(refreshThreshold) < new Date() ||
                    action.type !== actionTypes.REFRESH_USER_PROFILE) {
                    return this.refreshUserProfileEffect(action);
                }
                else {
                    return of(refreshUserProfileSuccess({
                        userState: store.user,
                        skipUpdate: true,
                    }));
                }
            }));
        });
        this.updateUserProfileMarketplace$ = createEffect(() => {
            return this.actions$.pipe(ofType(updateUserProfileMarketplace), exhaustMap((action) => {
                this.baseAPIService.set(action.endPoints.uriSecurity.setMarketplace);
                return this.baseAPIService
                    .post({
                    marketplace: action.marketplace,
                })
                    .pipe(map((result) => {
                    const userState = {
                        profile: this.transformUserProfile(result),
                        tokenExpires: result.tokenExpires,
                        tokenIssued: new Date().toString(),
                        sessionExpires: result.sessionExpires,
                        marketplace: result.marketplace,
                    };
                    return refreshUserProfileSuccess({
                        userState,
                        endPoints: action.endPoints,
                    });
                }), catchError(() => {
                    return of(refreshUserProfileFailure({
                        endPoints: action.endPoints,
                    }));
                }), ofType(refreshUserProfileSuccess), exhaustMap((successAction) => iif(() => successAction.userState.marketplace !== '' ||
                    !!successAction.skipUpdate, this.refreshUserProfileEffect(successAction), of(successAction))));
            }));
        });
        this.logout$ = createEffect(() => this.actions$.pipe(ofType(logout), exhaustMap((action) => {
            this.baseAPIService.set(action.endPoints.uriSecurity.logOut);
            return this.baseAPIService.get().pipe(map(() => {
                return logoutSuccess();
            }));
        }), catchError(() => {
            return of(logoutFailure());
        })));
        this.updateUserProfile$ = createEffect(() => this.actions$.pipe(ofType(updateUserProfile), exhaustMap((action) => {
            this.baseAPIService.set(action.endPoints.uriAdministration.updateUserProfile);
            return this.baseAPIService
                .post(this.updatedUserProfile(action.userProfile))
                .pipe(map(() => updateUserProfileSuccess({
                userProfile: action.userProfile,
                endPoints: action.endPoints,
            })), catchError((err) => {
                of(updateUserProfileFailure());
                return throwError(err);
            }));
        })));
        this.agreeToTerms$ = createEffect(() => this.actions$.pipe(ofType(agreeToTerms), withLatestFrom(this.store$), map(([action, { user: { profile }, },]) => updateUserProfile({
            userProfile: Object.assign(Object.assign({}, profile), { userInfo: Object.assign(Object.assign({}, profile.userInfo), { IsTermsSigned: 1 }) }),
            endPoints: action.endPoints,
        }))));
        this.updateUserProfileFromForm$ = createEffect(() => this.actions$.pipe(ofType(updateUserProfileFromForm), exhaustMap((action) => {
            this.baseAPIService.set(action.endPoints.uriAdministration.updateUserProfile);
            return this.baseAPIService.post(action.userProfile).pipe(map(() => {
                return updateUserProfileSuccess({
                    userProfile: action.userProfile,
                    endPoints: action.endPoints,
                });
            }), catchError((err) => {
                of(updateUserProfileFailure());
                return throwError(err);
            }));
        })));
        this.getMarketplaces$ = createEffect(() => this.actions$.pipe(ofType(getMarketplaces, setAccountSuccess), exhaustMap((action) => {
            this.baseAPIService.set(`${action.endPoints.uriMarketplacePartners.getAccountRelationship}/marketplaces`);
            return this.baseAPIService.get().pipe(map((result) => this.transformMarketplace(result, action.endPoints.uriDocServer.uploadAccountAssets)), map((marketplaces) => {
                return getMarketplacesSuccess({ marketplaces });
            }), catchError(() => of(getMarketplacesFailure())));
        })));
        this.loadSettings$ = createEffect(() => this.actions$.pipe(ofType(loadSettings, updateSettingsSuccess), exhaustMap((action) => {
            this.baseAPIService.set(action.endPoints.getUserState);
            return this.baseAPIService.get().pipe(map((data) => JSON.parse(data.state)), map((settings) => loadSettingsSuccess({
                settings: {
                    settings,
                },
            })), catchError(() => of(loadSettingsFailure({ settings: {} }))));
        })));
        this.updateSettings$ = createEffect(() => this.actions$.pipe(ofType(updateSettings), withLatestFrom(this.store$.select(settings)), exhaustMap(([action, settings]) => {
            this.baseAPIService.set(action.endPoints.getUserState);
            return this.baseAPIService
                .put({
                State: JSON.stringify(Object.assign(Object.assign({}, settings), { [action.stateKey]: action.state })),
            })
                .pipe(map(() => updateSettingsSuccess({ endPoints: action.endPoints })), catchError((err) => {
                of(updateSettingsFailure());
                return throwError(err);
            }));
        })));
        this.getAccounts$ = createEffect(() => this.actions$.pipe(ofType(getAccounts), exhaustMap((action) => {
            this.baseAPIService.set(`${action.endPoints.uriMarketplacePartners.account}/available`);
            return this.baseAPIService.get().pipe(map(({ records }) => {
                return getAccountsSuccess({ accounts: records });
            }), catchError(() => of(getAccountsFailure())));
        })));
        this.setAccount$ = createEffect(() => this.actions$.pipe(ofType(setAccount), exhaustMap((action) => {
            this.baseAPIService.set(`${action.endPoints.uriSecurity.setAccount}/${action.accountKey}`);
            return this.baseAPIService.post(action).pipe(map((userState) => setAccountSuccess({
                userState,
                endPoints: action.endPoints,
            })), catchError(() => {
                return of(setAccountFailure());
            }));
        })));
    }
    transformUserProfile(result) {
        const userProfile = {
            sub: result.sub,
            toolKeys: JSON.parse(result.toolKeys),
            userInfo: JSON.parse(result.userInfo),
        };
        return userProfile;
    }
    // change the shape of our state so it matches our API
    updatedUserProfile(userProfile) {
        return {
            firstName: userProfile.userInfo.FirstName,
            lastName: userProfile.userInfo.LastName,
            userName: userProfile.sub,
            languageCode: userProfile.userInfo.LanguageCode,
            timeZoneCode: userProfile.userInfo.TimeZoneCode,
            dateType: userProfile.userInfo.DateTypeKey,
            isTermsSigned: userProfile.userInfo.IsTermsSigned,
        };
    }
    transformMarketplace(marketplaces, url) {
        const data = marketplaces.accountRelationshipDetailsResponse === null
            ? []
            : marketplaces.accountRelationshipDetailsResponse.map((marketplace) => ({
                accountKey: marketplace.accountKey,
                accountLbmxId: marketplace.lbmxId,
                legalName: marketplace.legalName,
                dbaName: marketplace.dbaName,
                address1: marketplace.address1,
                address2: marketplace.address2,
                city: marketplace.city,
                postalCode: marketplace.postalCode,
                provinceName: marketplace.provinceName || marketplace.province.trim(),
                countryName: marketplace.countryName || marketplace.country.trim(),
                logo: marketplace.logo_AccountAssetKey
                    ? `${url}/${marketplace.logo_AccountAssetKey}?accountKey=${marketplace.accountKey}`
                    : '',
            }));
        return data;
    }
    refreshUserProfileEffect(action) {
        this.baseAPIService.set(action.endPoints.uriSecurity.slidingSession);
        return this.baseAPIService.get().pipe(map((result) => {
            const userState = {
                profile: this.transformUserProfile(result),
                tokenExpires: result.tokenExpires,
                tokenIssued: new Date().toString(),
                sessionExpires: result.sessionExpires,
                marketplace: result.marketplace,
            };
            return refreshUserProfileSuccess({
                userState,
                endPoints: action.endPoints,
            });
        }), catchError(() => {
            return of(refreshUserProfileFailure({
                endPoints: action.endPoints,
            }));
        }));
    }
};
UserEffects.ctorParameters = () => [
    { type: Actions },
    { type: BaseAPIService },
    { type: Store }
];
UserEffects = __decorate([
    Injectable()
], UserEffects);

const initialState = null;
const ɵ0$6 = (_, action) => (Object.assign({}, action.analytics)), ɵ1$3 = (_) => {
    return initialState;
}, ɵ2$3 = (_) => {
    return initialState;
};
const analyticsReducer = createReducer(initialState, on(loadAnalyticsConfigSuccess, ɵ0$6), on(logoutSuccess, ɵ1$3), on(logoutFailure, ɵ2$3));
function reducer$1(state, action) {
    return analyticsReducer(state, action);
}

const initialState$1 = { countries: [], provinces: [] };
const ɵ0$7 = (state, action) => {
    return Object.assign(Object.assign({}, state), { countries: action.countries });
}, ɵ1$4 = (state, action) => {
    return Object.assign(Object.assign({}, state), { provinces: action.provinces });
}, ɵ2$4 = (_) => {
    return initialState$1;
}, ɵ3$3 = (_) => {
    return initialState$1;
};
const configReducer = createReducer(initialState$1, on(loadCountriesSuccess, ɵ0$7), on(loadProvincesSuccess, ɵ1$4), on(logoutSuccess, ɵ2$4), on(logoutFailure, ɵ3$3));
function reducer$2(state, action) {
    return configReducer(state, action);
}

const initialState$2 = [];
const ɵ0$8 = (_, action) => {
    return [...action.navItems];
}, ɵ1$5 = (_) => {
    return initialState$2;
}, ɵ2$5 = (_) => {
    return initialState$2;
};
const navItemsReducer = createReducer(initialState$2, on(setNavItemsSuccess, ɵ0$8), on(logoutSuccess, ɵ1$5), on(logoutFailure, ɵ2$5));
function reducer$3(state, action) {
    return navItemsReducer(state, action);
}

const initialCategoryState = {};
const ɵ0$9 = (state, action) => {
    return Object.assign({}, action.categories);
}, ɵ1$6 = (_) => {
    return initialCategoryState;
}, ɵ2$6 = (_) => {
    return initialCategoryState;
};
const categoriesReducerCreator = createReducer(initialCategoryState, on(loadCategoriesSuccess, ɵ0$9), on(logoutSuccess, ɵ1$6), on(logoutFailure, ɵ2$6));
const initialState$3 = {};
const ɵ3$4 = (state, action) => {
    return Object.assign({}, action.productFields);
}, ɵ4$3 = (state, action) => {
    return Object.assign(Object.assign({}, state), action.productFields);
}, ɵ5$2 = (_) => {
    return initialState$3;
}, ɵ6$1 = (_) => {
    return initialState$3;
};
const productsReducerCreator = createReducer(initialState$3, on(loadProductFieldsSuccess, ɵ3$4), on(updateProductFieldsSuccess, ɵ4$3), on(logoutSuccess, ɵ5$2), on(logoutFailure, ɵ6$1));
function categoriesReducer(state, action) {
    return categoriesReducerCreator(state, action);
}
function productsReducer(state, action) {
    return productsReducerCreator(state, action);
}
const reducer$4 = {
    categories: categoriesReducer,
    productFields: productsReducer,
};

const initialState$4 = {
    profile: {
        sub: null,
        toolKeys: [],
        defaultModule: null,
        userInfo: {
            UserKey: null,
            FirstName: null,
            LastName: null,
            FullName: null,
            AccountKey: null,
            CompanyName: null,
            LanguageCode: null,
            AccountLBMXId: null,
            TimeZoneCode: null,
            DateTypeKey: null,
            DateTypeFormat: null,
            PrimeNGDateTypeFormat: null,
            DateTypeDescription: null,
            TimeFormat: null,
            TimeTypeDescription: null,
            IANATimeZoneCode: null,
            IsTermsSigned: null,
            MarketplaceSiteType: null,
            MarketplaceKey: null,
        },
    },
    tokenExpires: null,
    tokenIssued: null,
    sessionExpires: null,
    marketplace: null,
    marketplaces: null,
    settings: null,
};
const ɵ0$a = (state, action) => {
    return Object.assign(Object.assign({}, state), { profile: Object.assign(Object.assign({}, action.userProfile), { defaultModule: '/home' }) });
}, ɵ1$7 = (state, action) => {
    return action.skipUpdate
        ? state
        : Object.assign(Object.assign({}, state), { profile: Object.assign(Object.assign({}, action.userState.profile), { defaultModule: '/home' }), tokenExpires: action.userState.tokenExpires, tokenIssued: action.userState.tokenIssued, sessionExpires: action.userState.sessionExpires, marketplace: action.userState.marketplace });
}, ɵ2$7 = (state, action) => {
    return Object.assign(Object.assign({}, state), { marketplaces: action.marketplaces });
}, ɵ3$5 = (state) => {
    return Object.assign(Object.assign({}, state), { profile: Object.assign({}, initialState$4.profile) });
}, ɵ4$4 = (state, action) => {
    return Object.assign(Object.assign({}, state), action.settings);
}, ɵ5$3 = (state, action) => {
    return Object.assign(Object.assign({}, state), { settings: action.settings });
}, ɵ6$2 = (state) => {
    console.log('logoutSuccess');
    return Object.assign(Object.assign({}, state), initialState$4);
}, ɵ7$1 = (state) => {
    console.log('logoutFailure');
    return Object.assign(Object.assign({}, state), initialState$4);
};
const userReducer = createReducer(initialState$4, on(loadUserProfileSuccess, ɵ0$a), on(refreshUserProfileSuccess, ɵ1$7), on(getMarketplacesSuccess, ɵ2$7), on(unloadUserProfile, ɵ3$5), on(loadSettingsSuccess, ɵ4$4), on(loadSettingsFailure, ɵ5$3), on(logoutSuccess, ɵ6$2), on(logoutFailure, ɵ7$1));
function reducer$5(state, action) {
    return userReducer(state, action);
}

const initialState$5 = {};
const ɵ0$b = (state, action) => {
    return Object.assign(Object.assign({}, state), action.users);
}, ɵ1$8 = (_) => {
    return initialState$5;
}, ɵ2$8 = (_) => {
    return initialState$5;
};
const usersReducerCreator = createReducer(initialState$5, on(loadUsersSuccess, ɵ0$b), on(logoutSuccess, ɵ1$8), on(logoutFailure, ɵ2$8));
function reducer$6(state, action) {
    return usersReducerCreator(state, action);
}

let UsersEffects = class UsersEffects {
    constructor(actions$, baseAPIService) {
        this.actions$ = actions$;
        this.baseAPIService = baseAPIService;
        this.loadUsers$ = createEffect(() => this.actions$.pipe(ofType(loadUsers), exhaustMap((action) => {
            this.baseAPIService.set(action.endPoints.getUserFullName);
            return this.baseAPIService.get().pipe(map(this.transformUsers), catchError(() => of(loadUsersFailure())));
        })));
    }
    transformUsers(result) {
        const users = result.userDetailsResponse.reduce((prev, user) => {
            return Object.assign(Object.assign({}, prev), { [user.userKey]: Object.assign({}, user) });
        }, {});
        return loadUsersSuccess({ users });
    }
};
UsersEffects.ctorParameters = () => [
    { type: Actions },
    { type: BaseAPIService }
];
UsersEffects = __decorate([
    Injectable()
], UsersEffects);

let AnalyticsEffects = class AnalyticsEffects {
    constructor(actions$, baseAPIService) {
        this.actions$ = actions$;
        this.baseAPIService = baseAPIService;
        this.loadKPIs$ = createEffect(() => this.actions$.pipe(ofType(loadAnalyticsConfig), exhaustMap((action) => {
            this.baseAPIService.set(action.endPoints.getAnalyticsConfig);
            return this.baseAPIService.get().pipe(map((data) => {
                return loadAnalyticsConfigSuccess({
                    analytics: this.transform(data.value),
                });
            }), catchError(() => of(loadAnalyticsConfigFailure())));
        })));
    }
    transform(analytics) {
        const transformedCategories = Object.entries(analytics).reduce((categories, [key, value]) => {
            return Object.assign(Object.assign({}, categories), { [key]: value.description });
        }, {});
        const transformedKpis = Object.entries(analytics).reduce((kpis, [categoryKey, categoryValue]) => {
            return Object.assign(Object.assign({}, kpis), this.transformKpis(categoryKey, categoryValue.kpi));
        }, {});
        return {
            categories: transformedCategories,
            kpis: transformedKpis,
        };
    }
    transformKpis(categoryKey, categoryValue) {
        return Object.entries(categoryValue).reduce((categoryKpis, [kpiKey, kpiValue]) => {
            return Object.assign(Object.assign({}, categoryKpis), { [`${categoryKey}.${kpiKey}`]: kpiValue });
        }, {});
    }
};
AnalyticsEffects.ctorParameters = () => [
    { type: Actions },
    { type: BaseAPIService }
];
AnalyticsEffects = __decorate([
    Injectable()
], AnalyticsEffects);

let NavItemsEffects = class NavItemsEffects {
    constructor(actions$, baseAPIService) {
        this.actions$ = actions$;
        this.baseAPIService = baseAPIService;
        this.loadNavItems$ = createEffect(() => this.actions$.pipe(ofType(refreshUserProfileSuccess), exhaustMap((action) => {
            var _a, _b;
            this.baseAPIService.set(`${(_b = (_a = action === null || action === void 0 ? void 0 : action.endPoints) === null || _a === void 0 ? void 0 : _a.uriConfiguration) === null || _b === void 0 ? void 0 : _b.configurationRootURL}/navbar`);
            return (action === null || action === void 0 ? void 0 : action.skipUpdate) ? EMPTY
                : this.baseAPIService.get().pipe(map((navItemsResponse) => {
                    return setNavItemsSuccess({
                        navItems: navItemsResponse.records,
                    });
                }), catchError(() => of(setNavItemsFailure())));
        })));
    }
};
NavItemsEffects.ctorParameters = () => [
    { type: Actions },
    { type: BaseAPIService }
];
NavItemsEffects = __decorate([
    Injectable()
], NavItemsEffects);

let AppStateModule = class AppStateModule {
};
AppStateModule = __decorate([
    NgModule({
        declarations: [],
        imports: [
            CommonModule,
            EffectsModule.forRoot([]),
            EffectsModule.forFeature([
                AnalyticsEffects,
                ConfigEffects,
                NavItemsEffects,
                ProductEffects,
                UserEffects,
                UsersEffects,
            ]),
            StoreModule.forRoot(reducer, {
                runtimeChecks: {
                    strictStateImmutability: true,
                    strictActionImmutability: true,
                },
            }),
            StoreModule.forFeature('analytics', reducer$1),
            StoreModule.forFeature('config', reducer$2),
            StoreModule.forFeature('navItems', reducer$3),
            StoreModule.forFeature('product', reducer$4),
            StoreModule.forFeature('router', routerReducer),
            StoreModule.forFeature('user', reducer$5),
            StoreModule.forFeature('users', reducer$6),
            StoreDevtoolsModule.instrument({ maxAge: 25 }),
            StoreRouterConnectingModule.forRoot({
                stateKey: 'router',
                routerState: 1 /* Minimal */,
            }),
        ],
        providers: [SuccessMessageService],
    })
], AppStateModule);

/*
 * Public API Surface of app-state
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AppStateModule, actionTypes, index as actions, index$2 as interfaces, index$1 as selectors, sortFields, AnalyticsEffects as ɵa, ConfigEffects as ɵb, loadUserProfileSuccess as ɵba, refreshUserProfileSuccess as ɵbb, getMarketplacesSuccess as ɵbc, unloadUserProfile as ɵbd, loadSettingsSuccess as ɵbe, loadSettingsFailure as ɵbf, reducer$6 as ɵbg, loadUsersSuccess as ɵbh, loadAnalyticsConfig as ɵbi, loadAnalyticsConfigFailure as ɵbj, loadAnalyticsConfigSuccess as ɵbk, loadCountries as ɵbl, loadCountriesFailure as ɵbm, loadCountriesSuccess as ɵbn, loadProvinces as ɵbo, loadProvincesFailure as ɵbp, loadProvincesSuccess as ɵbq, setNavItems as ɵbr, setTranslatedNavItemsSuccess as ɵbs, setTranslatedNavItemsFailure as ɵbt, loadCategories as ɵbu, loadCategoriesFailure as ɵbv, loadCategoriesSuccess as ɵbw, loadProductFields as ɵbx, loadProductFieldsFailure as ɵby, loadProductFieldsSuccess as ɵbz, NavItemsEffects as ɵc, updateProductField as ɵca, updateProductFields as ɵcb, updateProductFieldsFailure as ɵcc, updateProductFieldsSuccess as ɵcd, loadUserProfile as ɵce, loadUserProfileFailure as ɵcf, loadUserProfileSuccess as ɵcg, getMarketplaces as ɵch, getMarketplacesSuccess as ɵci, getMarketplacesFailure as ɵcj, refreshUserProfile as ɵck, updateUserProfileMarketplace as ɵcl, refreshUserProfileFailure as ɵcm, refreshUserProfileSuccess as ɵcn, logout as ɵco, logoutSuccess as ɵcp, logoutFailure as ɵcq, unloadUserProfile as ɵcr, updateUserProfile as ɵcs, updateUserProfileFromForm as ɵct, updateUserProfileFailure as ɵcu, updateUserProfileSuccess as ɵcv, agreeToTerms as ɵcw, loadUsers as ɵcx, loadUsersSuccess as ɵcy, loadUsersFailure as ɵcz, ProductEffects as ɵd, unloadUsers as ɵda, UserEffects as ɵe, UsersEffects as ɵf, reducer as ɵg, analyticsReducer as ɵh, reducer$1 as ɵi, loadAnalyticsConfigSuccess as ɵj, logoutSuccess as ɵk, logoutFailure as ɵl, configReducer as ɵm, reducer$2 as ɵn, loadCountriesSuccess as ɵo, loadProvincesSuccess as ɵp, navItemsReducer as ɵq, reducer$3 as ɵr, setNavItemsSuccess as ɵs, categoriesReducer as ɵt, productsReducer as ɵu, reducer$4 as ɵv, loadCategoriesSuccess as ɵw, loadProductFieldsSuccess as ɵx, updateProductFieldsSuccess as ɵy, reducer$5 as ɵz };
//# sourceMappingURL=lbmx-app-state.js.map
